@if (!dismissed()) {
  @if (effectiveAlert(); as alert) {
    <div
      class="flex w-full gap-3 rounded-lg border px-4 py-3 text-sm transition-all"
      [class.items-center]="!alert.title"
      [class.items-start]="!!alert.title"
      [class.shadow-lg]="isSnackBar()"
      [class.sm:min-w-80]="isSnackBar()"
      [class.max-w-xl]="isSnackBar()"
      [ngClass]="alertClass()?.container"
    >
      @if (effectiveShowIcon()) {
        <mat-icon
          class="shrink-0 size-5 text-[20px] flex items-center justify-center leading-none select-none"
          [class.mt-0.5]="!!alert.title"
          [ngClass]="alertClass()?.icon"
        >
          @switch (alert.type) {
            @case (auraColorType.ERROR) {
              cancel
            }
            @case (auraColorType.SUCCESS) {
              check_circle
            }
            @case (auraColorType.WARN) {
              warning
            }
            @case (auraColorType.INFO) {
              info
            }
            @case (auraColorType.PRIMARY) {
              info
            }
            @default {
              info
            }
          }
        </mat-icon>
      }

      <div class="flex-1 min-w-0 flex flex-col justify-center">
        @if (alert.title) {
          <div class="font-semibold leading-5" [ngClass]="alertClass()?.title">
            {{ alert.title }}
          </div>
        }
        @if (alert.message) {
          <div class="leading-5" [class.mt-0.5]="!!alert.title" [ngClass]="alertClass()?.message">
            {{ alert.message }}
          </div>
        }

        <ng-content></ng-content>
      </div>

      @if (effectiveDismissible()) {
        <button
          mat-icon-button
          type="button"
          class="tiny shrink-0 -mr-1 text-current opacity-70 transition-opacity hover:opacity-100"
          [class.mt-0.5]="!!alert.title"
          (click)="dismiss()"
          aria-label="Fermer"
        >
          <mat-icon class="text-[18px]">close</mat-icon>
        </button>
      }
    </div>
  }
}
